<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <div class="btn-type1">
                <el-button size="mini" type="primary" icon="el-icon-search" @click="saveAll">
                    전체저장
                </el-button>
                <el-button size="mini" type="primary" icon="el-icon-search" @click="saveSelectedCust">
                    선택저장
                </el-button>
                <el-button size="mini" type="primary" icon="el-icon-search" @click="goOpen">
                    {{ this.$i18n.messages[this.$store.state.locale].search }}
                </el-button>
            </div>
            <div class="pop-content-search">
                <el-form size="mini" label-width="65px">
                    <el-row :gutter="24">
                        <el-col :span="15">
                            <el-col :span="6">
                                <el-select v-model="search.dtType">
                                    <el-option
                                        v-for="item in combos['dtType']"
                                        :key="item.value"
                                        :value="item.key"
                                        :label="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="8">
                            <el-date-picker type="date" placeholder="Pick a date" v-model="search.startDt" style="width: 90%;" value-format="yyyy-MM-dd" :picker-options="datePickerOptions"></el-date-picker>
                            </el-col>
                            <el-col :span="1" style="text-align: center;">-</el-col>
                            <el-col :span="8">
                            <el-date-picker type="date" placeholder="Pick a date" v-model="search.endDt" style="width: 90%;" value-format="yyyy-MM-dd" :picker-options="datePickerOptions"></el-date-picker>
                            </el-col>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="고객구분">
                                <el-select v-model="search.custType">
                                    <el-option
                                        v-for="item in combos['custType']"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="제품군">
                                <el-row>
                                    <el-col :span="subModelGroupShow ? 10: 20">
                                        <el-select v-model="modelGroup" @change="onModelGroupChange">
                                            <el-option value='' label="전체">전체</el-option>
                                            <el-option
                                                v-for="item in modelGroupList"
                                                :key="item.value"
                                                :label="item.value"
                                                :value="item.key">
                                            </el-option>
                                        </el-select>
                                        </el-col>
                                        <el-col :span="subModelGroupShow ? 10: 0">
                                            <el-select  v-model="subModelGroup" v-show="subModelGroupShow">
                                                <el-option value='' label="전체">전체</el-option>
                                                <el-option
                                                    v-for="item in subModelGroupList"
                                                    :key="item.value"
                                                    :label="item.value"
                                                    :value="item.key">
                                                </el-option>
                                            </el-select>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="접수유형">
                                <el-select v-model="search.asClass">
                                    <el-option value='' label="전체">전체</el-option>
                                    <el-option
                                        v-for="item in combos['asClass']"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="사이트명">
                                <el-col :span="8">
                                    <el-input type="text" v-model="search.siteNm1"></el-input>
                                </el-col>
                                <el-col :span="8">
                                    <el-input type="text" v-model="search.siteNm2"></el-input>
                                </el-col>
                                <el-col :span="8">
                                    <el-input type="text" v-model="search.siteNm3"></el-input>
                                </el-col>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="미결조건">
                                <el-select v-model="search.asTime">
                                    <el-option value='' label="전체">전체</el-option>
                                    <el-option
                                        v-for="item in combos['asTime']"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10" style="margin-left:-40px;">
                            <el-row>
                                <el-form-item label="지역/센터" label-width="120px">
                                <el-col :span="8">
                                    <el-select v-model="search.catId" @change="onCatIdChange">
                                    <el-option value='0' label="전체">전체</el-option>
                                    <el-option
                                        v-for="item in combos['catId']"
                                        :key="item.key"
                                        :value="item.key"
                                        :label="item.value">
                                    </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="12">
                                    <el-select v-model="search.subCatId" v-show="changeCatIdShow">
                                    <el-option value='0' label="전체">전체</el-option>
                                    <el-option
                                        v-for="item in combos['subCatId']"
                                        :key="item.key"
                                        :value="item.key"
                                        :label="item.value">
                                    </el-option>
                                    </el-select>
                                </el-col>
                                </el-form-item>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div class="table-area">
                <div class="table-b">
                    <ag-grid-vue 
                        style="width: 100%; height: 420px;"
                        class="ag-theme-alpine"    
                        row-selection="single"
                                
                        :column-defs="columnDefs"     
                        :grid-options="gridOptions"
                        :row-data="rowData"
                        :default-col-def="defaultColDef"
                        :framework-components="frameworkComponent"
                        @grid-ready="onGridReady"
                        @cell-clicked="onCellClicked" />
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';

/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}


export default {
    props: {
        tabData: {
            Type: Array
            , required: false
        },
        data: {}
    },
    components: {Layout, AgGridVue},
    data() {
        return {
            title: '대상자생성하기',
            
            search: {
                campaignId: '',
                startDt: this.$moment().format('YYYY-MM-DD'),
                endDt: this.$moment().format('YYYY-MM-DD'),
                dtType: '',                 // 기간타입
                custType: '',               // 고객구분
                asClass: '',                // 접수유형
                siteNm1: '',                // 사이트명1
                siteNm2: '',                // 사이트명2
                siteNm3: '',                // 사이트명3
                asTime: '',                 // 미결조건
                catId: '0',                 // 지역/센터
                subCatId: '0',
            },
            maker: '', /** 제조사 */
            makerList: [], /** 제조사 리스트*/
            modelGroup: '', /** 제품군 */
            modelGroupList: [], /** 제품군 리스트*/
            subModelGroup: '', /** 제품군 */
            subModelGroupList: [], /** 제품군 리스트*/
            subModelGroupShow: false,
            standardModelNm: '', /** 대표모델 */
            modelNm: '', /** 모델 */
            combos: {
                'dtType': [],
                'custType' : [],
                'asClass' : [],
                'asClass3' : [],
                'asTime' : [],
                'catId' : [],
                'subCatId' : [],
            },
            changeCatIdShow: false,

            // AG-GRID OPTION [START]
            rowData:[],
            gridOptions: {},
            columnDefs:[
                {
                    headerName:'선택',
                    field:'chk', 
                    width:80,
                    cellRenderer: 'checkBox',
                    cellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: false
                    }
                },
                {
                    headerName: '상담접수번호', 
                    width:150,
                    field:'asId', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '접수일자', 
                    width:140,
                    field:'callDt', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '접수유형', 
                    width:100,
                    field:'asClass', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '고객구분', 
                    width:100,
                    field:'custType', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '처리센터', 
                    width:150,
                    field:'allocationAsAgentNm', 
                    cellStyle:{textAlign:'center'}
                },  
                {
                    headerName: '사이트', 
                    width:200,
                    field:'siteNm', 
                    cellStyle:{textAlign:'center'}
                },  
                {
                    headerName: '신고자명', 
                    width:120,
                    field:'boundCustNm', 
                    cellStyle:{textAlign:'center'}
                },  
                {
                    headerName: '신고자전화번호', 
                    width:100,
                    field:'asTelNo', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '모델명', 
                    width:200,
                    field:'modelNm', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '대수', 
                    width:100,
                    field:'modelQty', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '접수자', 
                    width:120,
                    field:'creatorNm', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '처리일자', 
                    width:100,
                    field:'procDt', 
                    cellStyle:{textAlign:'center'}
                },                      
            ],
            defaultColDef: { 
                resizable: true, 
                filter:true, 
                sortable: true 
            },
            frameworkComponent : {
                checkBox: CheckboxCellRenderer,
            },
            //AG-GRID OPTION [END]
            form: {
                custId: '0',
                siteId: '0'
            },
            datePickerOptions: {
                disabledDate (date) {
                    return date < new Date('1971-01-01')
                }
            },
        }
    },
    mounted() {
        // this.form = this.tabData[0] ? this.tabData[0].param : {}
        this.getCombo({flag: 'INIT'});
        console.log('mount campaignId :',  this.data);
        this.search.campaignId = this.data.campaignId;
    },
    methods: {
        closeModal() {
            this.$emit('close');
            this.$parent.close();
        },
        onGridReady(){
            this.getCombo({flag: 'INIT'})
        },
        rowDoubleClick(params){
            this.$emit('close', params.data);
        },
        onCellClicked(event) {
            console.log('add onCellClicked  start===', event)
            // this.$emit('close', event);
            // this.closeModal();
        },
        getCombo(param) {
            if(param.flag === 'INIT'){
                
                // 기간타입 : HappyCallTargettingDtSearchType
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 27547}})
                    .then(response => {
                        this.combos['dtType'] = response.data || [];
                        this.search.dtType = this.combos['dtType'][0].key;
                    });

                // 고객구분 : CustType
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 10}})
                    .then(response => {
                        this.combos['custType'] = response.data || [];
                    });

                // 제품군 : ModelGroup, CAT_LVL(2)
                this.$http.get(`/api/asMng/call/topkey`, {params: {topKey: 'ModelGroup'}})
                    .then(response => {
                        this.modelGroupList = _.cloneDeep(response.data
                                                            .filter(x=>x.catLvl==2)
                                                            .map(y=>{
                                                                y.key = y.catKey;
                                                                y.value = y.catNm;
                                                                return {key: y.key, value: y.value, catId: y.catId};
                                                            })
                                                            ) || [];
                    });
 
                // AS미처리시간 : AsTime
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 27546}})
                    .then(response => {
                        this.combos['asTime'] = response.data || [];
                    });

                // 접수유형 : AsClass
                this.$http.get(`/api/asMng/call/topkey`, {params: {topKey: 'AsClass'}})
                    .then(response => {
                        this.combos['asClass'] = _.cloneDeep(response.data
                                                            .filter(x=>x.catLvl==2)
                                                            .map(y=>{
                                                                y.key = y.catKey;
                                                                y.value = y.catNm;
                                                                return {key: y.key, value: y.value, catId: y.catId};
                                                            })
                                                            ) || [];

                        const v2LvlObj = this.combos['asClass'];
                        this.combos['asClass3'] = _.cloneDeep(response.data
                                                            .filter(x=>x.catLvl==3)
                                                            .map(y=>{
                                                                y.key = y.catKey;
                                                                y.value = y.catNm;

                                                                const vTmpObj = v2LvlObj.filter(z=>z.catId===y.parentId);
                                                                y.cat23Nm = vTmpObj && vTmpObj.length>0 ? vTmpObj[0].value + '/' + y.catNm : y.catNm;

                                                                return {key: y.key, value: y.value, catId: y.catId, cat23Nm: y.cat23Nm};
                                                            })
                                                            ) || [];                                    
                    });
            
                // 지역/센터 : AreaAgent, CAT_LVL(2)
                this.$http.get(`/api/asMng/call/topkey`, {params: {topKey: 'AreaAgent'}})
                    .then(response => {
                        this.combos['catId'] = _.cloneDeep(response.data
                                                            .filter(x=>x.catLvl==2)
                                                            .map(y=>{
                                                                y.key = y.catKey;
                                                                y.value = y.catNm;
                                                                return {key: y.key, value: y.value, catId: y.catId};
                                                            })
                                                            ) || [];
                    });

            } else if(param.flag === 'MODEL_GROUP'){
                // 하위 제품군 : ModelGroup, CAT_LVL(3)
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.subModelGroupList = response.data || []
                        this.subModelGroup = ''
                    });
            
            } else if(param.flag === 'CENTER'){
                // 하위 지역/센터 : AreaAgent, CAT_LVL(3)
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.combos['subCatId'] = response.data || []
                        this.search.subCatId = '0'
                    });
            } 
        },
        onModelGroupChange(param){
            // 제품군 변경시

            this.subModelGroup = '';
            if(param === '') this.subModelGroupShow =  false;
            else{
                this.subModelGroupShow =  true;
                const vCatObj = this.modelGroupList.filter(x=>x.key===param);
                let vCatId = '';
                if(vCatObj && vCatObj.length>0){
                    vCatId = vCatObj[0].catId;
                }

                // 모델이 변경시 하위 제품군 조회
                this.getCombo({flag: 'MODEL_GROUP', parentId: vCatId});
            }
        },
        onCatIdChange(param){
            // 지역/센터 변경시

            this.search.subCatId = '0';
            if(param === '0') this.changeCatIdShow =  false;
            else{
                this.changeCatIdShow =  true;

                const vCatObj = this.combos['catId'].filter(x=>x.key===param);
                let vCatId = '';
                if(vCatObj && vCatObj.length>0){
                    vCatId = vCatObj[0].catId;
                }

                this.getCombo({flag: 'CENTER', parentId: vCatId});
            }
        },
        saveAll(){
            // 전체저장

            this.$swal({
                type: 'warning',
                text: `저장하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) { 

                    let vSelCatId = this.search.subCatId;
            
                    if(vSelCatId=='0' || vSelCatId==''){
                        
                        const vobj = this.combos['catId'].filter(x=>x.key===this.search.catId);
                        if(vobj && vobj.length>0){
                            vSelCatId = vobj[0].catId;
                        }
                    }

                    const vform = {
                        ...this.search,
                        catId: Number(vSelCatId) || 0,
                        modelGroup: this.subModelGroup ? this.subModelGroup : (this.modelGroup ? this.modelGroup : ''),
                        campaignId: this.search.campaignId
                    };

                    console.log('saveAll start', vform);
                    this.$store.commit('loading');
                    
                    this.$http.put(("/api/workMng/happyCallManager/saveAll"), vform
                        ).then(response => {
                        console.log('saveAll response.data' , response.data)
                        this.goOpen();
                        this.$swal({ type: 'warning', text: response.data });
                    }).finally(() => {
                        this.$store.commit('finish');
        
                    });
                }
            });
        },
        saveSelectedCust(){
            // 선택저장

            let vRowData = this.rowData.filter(x=>x.chk==='Y');
            
            if(!vRowData || (vRowData && vRowData.length===0)){
                this.$swal({ type: 'warning', text: '추가할 대상자를 선택해 주세요.' });
                return false;
            }
            
            const vAsIds = [];
            vRowData.map(x=>{
                vAsIds.push(x.asId);
                return x;
            });

            const vform = {
                campaignId: this.search.campaignId,
                asIds: vAsIds
            }
            console.log('add goOpen start', vform)
            this.$store.commit('loading')
            
            this.$http.put(("/api/workMng/happyCallManager/saveSelectedCust"), vform
                ).then(response => {
                console.log('saveSelectedCust response.data' , response.data)
                this.goOpen();
                this.$swal({ type: 'success', text: response.data });
            }).finally(() => {
                this.$store.commit('finish')
 
            });
            
        },
        goOpen(){
            this.$store.commit('loading')
            
            let vSelCatId = this.search.subCatId;
            if(vSelCatId=='0' || vSelCatId==''){
                
                const vobj = this.combos['catId'].filter(x=>x.key===this.search.catId);
                if(vobj && vobj.length>0){
                    vSelCatId = vobj[0].catId;
                }
            }
            

            const vform = {
                ...this.search,
                catId: Number(vSelCatId) || 0,
                modelGroup: this.subModelGroup ? this.subModelGroup : (this.modelGroup ? this.modelGroup : ''),
                sortType: '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            }
             console.log('add goOpen start', vform)
            this.$http.post(("/api/workMng/popup/happyCallManager/selectTargettingPage"), vform
                ).then(response => {
                console.log('addmodal response.data' , response.data)
                if(response.data){
                    this.rowData = response.data.map(x=>{
                        x.siteNm = (x.siteNm1 || '') + ' ' + (x.siteNm2 || '') + ' ' + (x.siteNm3 || '');
                        x.asTelNo = _phone(x.asTelNo);
                        x.callDt = x.callDt && x.callDt.length>=16 ? x.callDt.substring(0, 16) : '';
                        x.procDt = x.procDt && x.procDt.length>=16 ? x.procDt.substring(0, 16) : '';

                        const vCustTypeObj = this.combos['custType'].filter(y=>y.key===x.custType);
                        x.custType = vCustTypeObj && vCustTypeObj.length>0 ? vCustTypeObj[0].value : '';

                        const vAsClassObj = this.combos['asClass3'].filter(y=>y.key===x.asClass||y.value===x.asClass);
                        if(vAsClassObj && vAsClassObj.length>0){
                            x.asClass = vAsClassObj[0].cat23Nm;
                        }

                        return x;
                    }) || []
                }
                
            }).finally(() => {
                this.$store.commit('finish')
 
            });
        }
    }
}
</script>

<style lang="scss" scoped>
// .modal-card {
//   width: 970px;
// }

// .display-area {
//   :global(img) {
//     width: 100%;
//   }
// }
</style>